import React from 'react';

import PropTypes from 'prop-types';
import { FaTimes } from 'react-icons/fa';

import { Label6 } from '@src/theme';
import { bemClassName } from '@src/utils/bem';

import { StyledActiveFilters } from './styles';

const b = bemClassName('active-filters');

const ActiveFilters = ({ filters, onClearFilter, onClearAll }) => {
  const hasFilters = filters && filters.length > 0;

  if (!hasFilters) {
    return null;
  }

  return (
    <StyledActiveFilters>
      <div className={b()}>
        <div className={b('header')}>
          <div className={b('header', 'label')}>
            <Label6>Active Filters:</Label6>
          </div>
          <button onClick={onClearAll} className={b('header', 'clear-all')}>
            Clear All
          </button>
        </div>
        <div className={b('chips')}>
          {filters.map((filter) => (
            <div key={filter.key} className={b('chips', 'chip')}>
              <div className={b('chips', 'chip', 'label')}>
                <Label6>
                  <span className={b('chips', 'chip', 'label', 'type')}>{filter.type}:</span> {filter.value}
                </Label6>
              </div>
              <button onClick={() => onClearFilter(filter.key)} className={b('chips', 'chip', 'remove')}>
                <FaTimes />
              </button>
            </div>
          ))}
        </div>
      </div>
    </StyledActiveFilters>
  );
};

ActiveFilters.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onClearFilter: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
};

export default ActiveFilters;
